import { Divider, Grid } from '@mui/material'
import {
  FormikSelect,
  FormikTextField,
  LocalizedCombobox,
  TitledSection,
  UpdateForm
} from '../../../../components'
import { SAVE_USER_INFO } from '../../../../graphql'
import {
  useLocalizedBusinessLanguages,
  useUserRenderWrapper
} from '../../../../hooks'
import { isRequired } from '../../../../utils/validation'
import { Addresses, BottomBar, Emails, Phones } from './components'
import { useBaseDetailsFormData } from './hooks/useBaseDetailsFormData'
import { InformationReleases } from './components/information-releases'
import { AlertProvider } from '../../../../contexts'

export const BaseDetails = () => {
  const localizedBusinessLanguageOptions = useLocalizedBusinessLanguages()

  const { UserRenderWrapper, user, refreshUserData } = useUserRenderWrapper()

  const { createVariables, getErrorMessage, initialValues, validationSchema } =
    useBaseDetailsFormData(user)

  return (
    <AlertProvider clearAlerts={true}>
      <UserRenderWrapper>
        {user && (
          <UpdateForm
            query={SAVE_USER_INFO}
            createVariablesFn={createVariables}
            noValidate
            formikProps={{
              initialValues,
              validationSchema,
              validateOnChange: false,
              validateOnBlur: false
            }}
            submitCheckerProps={{
              successFn: refreshUserData,
              successMessageId: 'pages.ownInfoPage.baseDetails.save.success',
              errorMessageFn: getErrorMessage,
              errorMessageId: 'pages.ownInfoPage.baseDetails.save.error'
            }}
          >
            <TitledSection translationid="pages.ownInfoPage.baseDetails.personalInformation.label">
              <Grid container spacing={4}>
                <FormikTextField
                  name="nimi.sukunimi"
                  required={isRequired('nimi.sukunimi', validationSchema)}
                  labelTranslationId="pages.ownInfoPage.baseDetails.personalInformation.lastName.text"
                />
                <FormikTextField
                  name="nimi.etunimet"
                  required={isRequired('nimi.sukunimi', validationSchema)}
                  labelTranslationId="pages.ownInfoPage.baseDetails.personalInformation.firstNames.text"
                />
                <FormikTextField
                  name="nimi.kutsumanimi"
                  required={isRequired('nimi.sukunimi', validationSchema)}
                  labelTranslationId="pages.ownInfoPage.baseDetails.personalInformation.callingName.text"
                />
                <FormikTextField
                  disabled
                  name="jasennumero"
                  labelTranslationId="pages.ownInfoPage.baseDetails.personalInformation.memberId"
                />
                <LocalizedCombobox
                  name="kansalaisuus.kansalaisuusKoodi"
                  localizedOptionsKey="countryOptions"
                  labelTranslationId="pages.ownInfoPage.baseDetails.personalInformation.nationality"
                />
              </Grid>
            </TitledSection>
            <TitledSection translationid="pages.ownInfoPage.baseDetails.communication.label">
              <Grid container spacing={4}>
                <LocalizedCombobox
                  name="aidinkieli.aidinkieliKoodi"
                  localizedOptionsKey="languageOptions"
                  labelTranslationId="pages.ownInfoPage.baseDetails.communication.nativeLanguage"
                />
                <FormikSelect
                  name="asiointikieli"
                  options={localizedBusinessLanguageOptions}
                  labelTranslationId="pages.ownInfoPage.baseDetails.communication.businessLanguage"
                />
                <Grid item md={12}>
                  <Divider sx={{ mt: 1 }} />
                </Grid>
                <Grid item md={12}>
                  <InformationReleases />
                </Grid>
              </Grid>
            </TitledSection>
            <Addresses />
            <Phones />
            <Emails />
            <BottomBar />
          </UpdateForm>
        )}
      </UserRenderWrapper>
    </AlertProvider>
  )
}
